import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const download: ISVGPersonalProps = {
  viewBox: '0 0 25.135 25.135',
  fill: 'currentColor',
  content: (
    <>
      <path
        id="Path_7182"
        data-name="Path 7182"
        d="M9.412,23.188H22.681M20.3,16l-4.189,4.189m0,0L11.921,16m4.189,4.189V10"
        transform="translate(-3.543 -4.026)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path id="Path_7183" data-name="Path 7183" d="M0,0H25.135V25.135H0Z" fill="none" />
    </>
  ),
};
